import { render } from "./TheHomeCustom.vue?vue&type=template&id=120d696d"
const script = {}
script.render = render

export default script